import { UnrecoverableErrorStoreType } from '../types'

import { createReactStore } from '@/utils/create-react-store'

export const UnrecoverableErrorStore =
  createReactStore<UnrecoverableErrorStoreType>(() => ({
    /** This value is set by {@link registerPage} */
    pageSuffix: 'XX',
    /** This value is set by {@link registerPage} */
    analyticsConfig: undefined,
  }))
